import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getHistoryTransferMembership(params) {
	return client.get("binary/serial-transfer/history-membership", {
		params: params,
	});
}

function getHistoryTransferActivation(params) {
	return client.get("binary/serial-transfer/history-activation", {
		params: params,
	});
}

export default {
	getHistoryTransferMembership,
	getHistoryTransferActivation,
};